import { type Plugin } from "vue";
import GoogleMap from "./components/GoogleMap.vue";
import GoogleMapControl from "./components/GoogleMapControl.vue";
import GoogleMapMarker from "./components/GoogleMapMarker.vue";
import GoogleMapMarkerCluster from "./components/GoogleMapMarkerCluster.vue";
import GoogleMapOverlay from "./components/GoogleMapOverlay.vue";
import GoogleMapPolyline from "./components/GoogleMapPolyline.vue";
import { useExposedMap } from "./composable/exposed-map";
import { useMap } from "./composable/google-map";
import { initGoogleMap } from "./init";
import { LibLoader, useLib } from "./lib-loader";

type GoogleMapPluginOptions = {
	key: string;
} & google.maps.MapOptions;

export function createGoogleMap(options: GoogleMapPluginOptions): Plugin {
	initGoogleMap({
		key: options.key,
		v: "weekly",
		region: "CA",
	});

	return {
		install() {},
	};
}

export { type onClusterClickHandler } from "@googlemaps/markerclusterer";
export type { MarkerOptions as Marker, MarkerMeta } from "./composable/markers";

export {
	GoogleMap,
	GoogleMapControl,
	GoogleMapMarker,
	GoogleMapMarkerCluster,
	GoogleMapOverlay,
	GoogleMapPolyline,
	LibLoader,
	useExposedMap,
	useLib,
	useMap,
};
